import React from 'react';
import { Link } from 'react-router-dom';
import { ZODIAC_SIGNS } from '../data/astroData';
import { useLanguage } from '../context/LanguageContext';

const featureKeys = [
  { path: '/horoscope', icon: '🪷', titleKey: 'featureDailyHoroscope', descKey: 'featureDailyHoroscopeDesc' },
  { path: '/kundali', icon: '🪬', titleKey: 'featureKundali', descKey: 'featureKundaliDesc' },
  { path: '/moon', icon: '🌙', titleKey: 'featureMoonPhase', descKey: 'featureMoonPhaseDesc' },
  { path: '/compatibility', icon: '💕', titleKey: 'featureCompatibility', descKey: 'featureCompatibilityDesc' },
  { path: '/nakshatra', icon: '⭐', titleKey: 'featureNakshatra', descKey: 'featureNakshatraDesc' },
  { path: '/muhurat', icon: '📅', titleKey: 'featureMuhurat', descKey: 'featureMuhuratDesc' },
  { path: '/numerology', icon: '🔢', titleKey: 'featureNumerology', descKey: 'featureNumerologyDesc' },
  { path: '/tarot', icon: '🃏', titleKey: 'featureTarotReading', descKey: 'featureTarotReadingDesc' },
  { path: '/vedic', icon: '🕉️', titleKey: 'featureVedicAstrology', descKey: 'featureVedicAstrologyDesc' },
  { path: '/remedies', icon: '🙏', titleKey: 'featureRemedies', descKey: 'featureRemediesDesc' },
  { path: '/transits', icon: '🪐', titleKey: 'featurePlanetaryTransits', descKey: 'featurePlanetaryTransitsDesc' },
  { path: '/chinese', icon: '🐉', titleKey: 'featureChineseZodiac', descKey: 'featureChineseZodiacDesc' },
  { path: '/palm', icon: '🖐️', titleKey: 'featurePalmReading', descKey: 'featurePalmReadingDesc' },
  { path: '/ask', icon: '✨', titleKey: 'featureAskAstrologer', descKey: 'featureAskAstrologerDesc' },
];

export default function Home() {
  const { t } = useLanguage();

  return (
    <div className="page">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-zodiac-ring">
          {ZODIAC_SIGNS.map((s, i) => (
            <img key={s.name} src={`/images/horoscope/${i + 1}.png`} alt={s.name} title={s.name} style={{ width: 40, height: 40, objectFit: 'contain' }} />
          ))}
        </div>
        <h1>AstroA2Z</h1>
        <p>{t('heroTagline')}</p>
        <div className="hero-buttons">
          <Link to="/horoscope" className="btn btn-primary">{t('heroBtn1')}</Link>
          <Link to="/kundali" className="btn btn-secondary">{t('heroBtn2')}</Link>
          <Link to="/ask" className="btn btn-gold">{t('heroBtn3')}</Link>
        </div>
      </section>

      {/* Features Grid */}
      <section className="container">
        <div className="page-header">
          <h2>{t('exploreTitle')}</h2>
          <p>{t('exploreDesc')}</p>
        </div>
        <div className="features-grid">
          {featureKeys.map(f => (
            <Link to={f.path} className="feature-card" key={f.path}>
              <span className="icon">{f.icon}</span>
              <h3>{t(f.titleKey)}</h3>
              <p>{t(f.descKey)}</p>
            </Link>
          ))}
        </div>
      </section>

      {/* Zodiac Quick View */}
      <section className="container" style={{ marginTop: '4rem' }}>
        <div className="page-header">
          <h2>{t('zodiacTitle')}</h2>
          <p>{t('zodiacDesc')}</p>
        </div>
        <div className="zodiac-grid">
          {ZODIAC_SIGNS.map(sign => (
            <Link
              to={`/horoscope?sign=${sign.name}`}
              key={sign.name}
              className="zodiac-card"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div className="zodiac-circle" style={{ background: sign.color }}>
                <span className="symbol">{sign.emoji}</span>
              </div>
              <span className="rashi-name">{sign.rashi}</span>
              <span className="name">{sign.name}</span>
            </Link>
          ))}
        </div>
      </section>

      <div className="section-divider" style={{ marginTop: '3rem' }}>🪷 ॐ 🪷</div>
    </div>
  );
}
